module.exports = __webpack_public_path__ + "img/move-puce.68350b0e.jpg";